
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage, ElMessageBox } from "element-plus";
import MiezzModal, { MiezzModalType } from "@/models/MiezzModal";
import DtoFormPriceQuotationSheet from "@/models.machine/DtoFormPriceQuotationSheet";
import MiezzForm from "@/models/MiezzForm";
import MiezzButton from "@/models/MiezzButton";
import OrderPoolAppService from "@/apis.machine/OrderPoolAppService";
import UiSelectOptionWithStringValue from "@/models.machine/UiSelectOptionWithStringValue";
import UiSelectOption from "@/models.machine/UiSelectOption";
import DtoDeleteServiceRemark from "@/models.machine/DtoDeleteServiceRemark";
import ParamPriceCostAppService from "@/apis.machine/ParamPriceCostAppService";
import ParamCurrencySystemAppService from "@/apis.machine/ParamCurrencySystemAppService";
import DtoFormPriceQuotationSheet_PriceQuotationSheetItem from "@/models.machine/DtoFormPriceQuotationSheet_PriceQuotationSheetItem";
import ParamPriceFieldAppService from "@/apis.machine/ParamPriceFieldAppService";
import { EnumParamPriceFieldType } from "@/models.machine/EnumParamPriceFieldType";
import {
  EnumVoyageUnit,
  EnumVoyageUnitOption,
} from "@/models.machine/EnumVoyageUnit";
import {
  EnumSailingTimeType,
  EnumSailingTimeTypeOption,
} from "@/models.machine/EnumSailingTimeType";
import ParamCountryAppService from "@/apis.machine/ParamCountryAppService";
import ParamPortAppService from "@/apis.machine/ParamPortAppService";
import ParamCountryAreaAppService from "@/apis.machine/ParamCountryAreaAppService";
import ParamCarrierAppService from "@/apis.machine/ParamCarrierAppService";
import ParamTransportChannelAppService from "@/apis.machine/ParamTransportChannelAppService";
import ParamTransportRouteCodeAppService from "@/apis.machine/ParamTransportRouteCodeAppService";
import { EnumWeekOption } from "@/models.machine/EnumWeek";
import vuedraggable from "vuedraggable";
import DtoDetailPriceQuotationSheetSourceItem from "@/models.machine/DtoDetailPriceQuotationSheetSourceItem";
import DtoSelectOptionCompany from "@/models.machine/DtoSelectOptionCompany";
import CompanyContactAppService from "@/apis.machine/CompanyContactAppService";
import MiezzInput from "@/components/MiezzInput.vue";
import PriceQuotationSheetAppService from "@/apis.machine/PriceQuotationSheetAppService";
import DtoFormPriceQuotationSheet_Scheme from "@/models.machine/DtoFormPriceQuotationSheet_Scheme";

@Options({
  components: {
    vuedraggable,
  },
})
export default class FormSchemes extends Vue {
  @Model() form!: MiezzForm<DtoFormPriceQuotationSheet, string>;
  @Prop() powers: string[] = [];
  @Prop() serviceRemarks: UiSelectOptionWithStringValue[] = [];
  @Prop() costs: UiSelectOption<string>[] = [];
  @Prop() currencySystems: UiSelectOption<string>[] = [];
  @Prop() units: UiSelectOption<string>[] = [];
  @Prop() infoCollectors: UiSelectOption<string>[] = [];
  @Prop() suppliers: DtoSelectOptionCompany[] = [];

  filterCosts: UiSelectOption<string>[] = [];
  rules: any = {};
  schemeName?: string = "";
  modalScheme = new MiezzModal(MiezzModalType.Dialog);
  modalDataScheme: {
    Name?: string;
    CopyName?: string;
  } = {
    Name: undefined,
    CopyName: undefined,
  };
  deleteItemBtn: MiezzButton = {
    Code: "delete-item",
    Icon: "delete",
    Title: "删除",
    Type: "danger",
    Size: "small",
  };
  addItemBtn: MiezzButton = {
    Code: "add-item",
    Icon: "plus",
    Label: "添加",
    Type: "text",
    Size: "small",
  };

  fields: UiSelectOption<string>[] = [];
  addFieldBtn: MiezzButton = {
    Code: "add-field",
    Icon: "plus",
    Label: "添加要素",
    Type: "text",
    Size: "small",
  };
  fieldRowBtns: MiezzButton[] = [
    {
      Code: "delete-field",
      Icon: "delete",
      Title: "删除",
      Type: "default",
      Size: "small",
    },
    {
      Code: "drag-sort-field",
      Title: "拖曳",
      Icon: "Rank",
      Type: "default",
      Size: "small",
    },
  ];
  modalField = new MiezzModal(MiezzModalType.Dialog);
  modalFieldForm: {
    CheckAll: boolean;
    CheckAllIndeterminate: boolean;
    Ids: string[];
  } = {
    CheckAll: false,
    CheckAllIndeterminate: false,
    Ids: [],
  };
  modalFieldFormRule = {
    Ids: [
      {
        required: true,
        message: "信息不能为空",
        trigger: "change",
      },
    ],
  };
  EnumSailingTimeType = EnumSailingTimeType;
  EnumWeekOption = EnumWeekOption;

  _suppliers: DtoSelectOptionCompany[] = [];
  modalSupplier = new MiezzModal(MiezzModalType.Dialog);
  modalDataSupplier: {
    SupplierName?: string;
    SupplierContacts?: string;
  } = {
    SupplierName: undefined,
    SupplierContacts: undefined,
  };

  created(): void {
    this.modalScheme.Title = "添加方案";
    this.modalScheme.Width = "700px";
    this.modalScheme.Height = "120px";
    this.modalScheme.HandleClick = this.handleClick;
    this.modalScheme.Buttons = [
      {
        Code: "add-scheme-submit",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];

    this.modalField.Title = "添加";
    this.modalField.Width = "700px";
    this.modalField.Height = "100px";
    this.modalField.Buttons = [
      {
        Code: "field-submit",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];
    this.modalField.HandleClick = this.handleClick;

    this.modalSupplier.Title = "添加供应商";
    this.modalSupplier.Width = "700px";
    this.modalSupplier.Height = "120px";
    this.modalSupplier.HandleClick = this.handleClick;
    this.modalSupplier.Buttons = [
      {
        Code: "add-supplier-submit",
        Label: "保存",
        Type: "primary",
        Size: "small",
      },
    ];

    this.rules.SupplierName = [
      {
        validator: (rule: any, value: string, callback: any) => {
          if (!value) {
            return callback(new Error("信息不能为空"));
          } else {
            const scheme = this.form.Data.Schemes?.firstOrDefault(
              (it) => it.Name == this.schemeName
            );
            if (
              scheme &&
              this.modalDataSupplier.SupplierName != scheme.SupplierName &&
              scheme.Suppliers?.any(
                (it) => it.SupplierName == this.modalDataSupplier.SupplierName
              )
            ) {
              callback(new Error("信息重复，请重新填写"));
            }
            callback();
          }
        },
        required: true,
        trigger: "blur",
      },
    ];
    this.rules.SchemeName = [
      {
        validator: (rule: any, value: string, callback: any) => {
          if (!value) {
            return callback(new Error("信息不能为空"));
          } else if (
            this.modalDataScheme.Name != this.schemeName &&
            this.form.Data.Schemes?.any(
              (it) => it.Name == this.modalDataScheme.Name
            )
          ) {
            callback(new Error("信息重复，请重新填写"));
          }
          callback();
        },
        required: true,
        trigger: "change",
      },
    ];
    this.rules.FiledName = [
      {
        validator: (rule: any, value: any, callback: any) => {
          const regex = /\[(\w+)\]/g;
          let matches = [];
          let match;
          while ((match = regex.exec(rule.field)) !== null) {
            matches.push(match[1]);
          }
          const i = parseInt(matches[0]);
          console.log(rule.field, i, matches);
          if (!value) {
            callback(new Error("信息不能为空"));
          } else if (value.length > 256) {
            callback(new Error("文本长度不能超过 256 个字符"));
          } else if (
            (this.form.Data.Schemes![i].FieldValues?.filter(
              (it: any) => it.Name == value
            ).length ?? 0) > 1
          ) {
            callback(new Error("信息重复，请重新填写"));
          } else {
            callback();
          }
        },
        trigger: "blur",
      },
    ];
    this.rules.FieldId = [
      {
        required: true,
        message: "信息不能为空",
        trigger: "change",
      },
    ];
    this.rules.CostId = [
      {
        required: true,
        message: "信息不能为空",
        trigger: "change",
      },
      {
        required: true,
        message: "信息不能为空",
        trigger: "blur",
      },
    ];
    this.rules.CurrencySystemId = [
      {
        required: true,
        message: "信息不能为空",
        trigger: "change",
      },
    ];
    this.rules.FirstChargingNumber = [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (value != undefined && value <= 0) {
            return callback(new Error("仅可录入＞0的数值"));
          }
          callback();
        },
        trigger: "blur",
      },
    ];
    this.rules.SecondChargingNumber = [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (value != undefined && value <= 0) {
            return callback(new Error("仅可录入＞0的数值"));
          }
          callback();
        },
        trigger: "blur",
      },
    ];
  }

  handleInit(): void {
    ParamPriceFieldAppService.GetSelect({
      Types: [EnumParamPriceFieldType.Description],
    }).then((r) => {
      if ((this.form.Data.Schemes?.length ?? 0) == 0) {
        this.form.Data.Schemes?.push({
          Name: "方案1",
          FieldValues: [],
          Items: [],
          Totals: [],
          Suppliers: [],
        });
        this.schemeName = "方案1";
      } else {
        this.schemeName = this.form.Data.Schemes![0].Name;
      }
      this.fields = r.data.Data ?? [];
      this.buildFields();
      for (const scheme of this.form.Data.Schemes ?? []) {
        if ((scheme.Suppliers?.length ?? 0) > 0) {
          scheme.SupplierName = scheme.Suppliers![0].SupplierName;
        }
      }
      this.handleCalc();
      this.handleSupplierCalc();
    });
  }

  handleEditSchemes(schemeName?: string, action?: string): void {
    this.schemeName = schemeName;
    if (action == "add") {
      this.modalDataScheme.Name = undefined;
      this.modalDataScheme.CopyName = undefined;
      this.modalScheme.Title = "添加方案";
      this.modalScheme.Show = true;
    } else if (action == "copy") {
      this.modalDataScheme.Name = undefined;
      this.modalDataScheme.CopyName = this.schemeName;
      this.schemeName = undefined;
      this.modalScheme.Title = "复制方案";
      this.modalScheme.Show = true;
    } else if (action == "edit") {
      const scheme = this.form.Data.Schemes?.firstOrDefault(
        (it) => it.Name == this.schemeName
      );
      this.modalDataScheme.Name = scheme?.Name;
      this.modalDataScheme.CopyName = undefined;
      this.modalScheme.Title = "编辑名称";
      this.modalScheme.Show = true;
    } else if (action == "delete") {
      this.modalDataScheme.CopyName = undefined;
      let index = this.form.Data.Schemes?.findIndex(
        (it) => it.Name == schemeName
      );
      if (index != undefined && this.form.Data.Schemes) {
        this.form.Data.Schemes?.splice(index, 1);
        setTimeout(() => {
          if (
            index != undefined &&
            this.form.Data.Schemes &&
            this.form.Data.Schemes.length != 0
          ) {
            if (index >= 0 && index < this.form.Data.Schemes.length) {
              this.schemeName = this.form.Data.Schemes[index].Name;
            } else if (index == this.form.Data.Schemes.length) {
              this.schemeName = this.form.Data.Schemes[index - 1].Name;
            }
          }
        }, 100);
      }
    }
  }

  handleEditSuppliers(supplierName?: string, action?: string): void {
    const scheme = this.form.Data.Schemes?.firstOrDefault(
      (it) => it.Name == this.schemeName
    );
    if (scheme) {
      scheme.SupplierName = supplierName;
      if (action == "add") {
        this.modalDataSupplier.SupplierName = undefined;
        this.modalDataSupplier.SupplierContacts = undefined;
        this._suppliers = this.suppliers.filter((it) =>
          scheme.Suppliers?.all((s) => s.SupplierName != it.Name)
        );
        this.modalSupplier.Title = "添加供应商";
        this.modalSupplier.Show = true;
      } else if (action == "edit") {
        const supplier = scheme.Suppliers?.firstOrDefault(
          (it) => it.SupplierName == scheme.SupplierName
        );
        this.modalDataSupplier.SupplierName = supplier?.SupplierName;
        this.modalDataSupplier.SupplierContacts = supplier?.SupplierContacts;
        this._suppliers = this.suppliers.filter(
          (it) =>
            scheme.Suppliers?.all((s) => s.SupplierName != it.Name) ||
            it.Name == supplierName
        );
        this.modalSupplier.Title = "编辑名称";
        this.modalSupplier.Show = true;
      } else if (action == "delete") {
        let index = scheme.Suppliers?.findIndex(
          (it) => it.SupplierName == supplierName
        );
        if (index != undefined && scheme.Suppliers) {
          scheme.Suppliers?.splice(index, 1);
          setTimeout(() => {
            if (
              index != undefined &&
              scheme.Suppliers &&
              scheme.Suppliers.length != 0
            ) {
              if (index >= 0 && index < scheme.Suppliers.length) {
                scheme.SupplierName = scheme.Suppliers[index].SupplierName;
              } else if (index == scheme.Suppliers.length) {
                scheme.SupplierName = scheme.Suppliers[index - 1].SupplierName;
              }
            }
          }, 100);
        }
      }
    }
  }

  handleCalc(): void {
    this.$nextTick(() => {
      for (const scheme of this.form.Data.Schemes ?? []) {
        scheme.Totals = [];
        for (const item of scheme.Items ?? []) {
          item.Total = undefined;
          if (
            item.Amount != undefined &&
            (item.FirstChargingNumber != undefined ||
              item.SecondChargingNumber != undefined)
          ) {
            if (
              item.FirstChargingNumber != undefined &&
              item.SecondChargingNumber != undefined
            ) {
              item.Total =
                item.Amount *
                item.FirstChargingNumber *
                item.SecondChargingNumber;
            } else if (item.FirstChargingNumber != undefined) {
              item.Total = item.Amount * item.FirstChargingNumber;
            } else if (item.SecondChargingNumber != undefined) {
              item.Total = item.Amount * item.SecondChargingNumber;
            }
          }
          if (item.Total) {
            let total = scheme.Totals.firstOrDefault(
              (it: any) => it.CurrencySystem == item.CurrencySystem.Code
            );
            if (total) {
              total.Amount += item.Total;
            } else {
              total = {
                CurrencySystem: item.CurrencySystem.Code,
                Amount: item.Total,
              };
              scheme.Totals.push(total);
            }
          }
        }
      }
    });
  }

  handleSupplierCalc(): void {
    this.$nextTick(() => {
      for (const scheme of this.form.Data.Schemes ?? []) {
        for (const supplier of scheme.Suppliers ?? []) {
          supplier.Totals = [];
          for (const item of supplier.Items ?? []) {
            item.Total = undefined;
            if (
              item.Amount != undefined &&
              (item.FirstChargingNumber != undefined ||
                item.SecondChargingNumber != undefined)
            ) {
              if (
                item.FirstChargingNumber != undefined &&
                item.SecondChargingNumber != undefined
              ) {
                item.Total =
                  item.Amount *
                  item.FirstChargingNumber *
                  item.SecondChargingNumber;
              } else if (item.FirstChargingNumber != undefined) {
                item.Total = item.Amount * item.FirstChargingNumber;
              } else if (item.SecondChargingNumber != undefined) {
                item.Total = item.Amount * item.SecondChargingNumber;
              }
            }
            if (item.Total) {
              let total = supplier.Totals.firstOrDefault(
                (it: any) => it.CurrencySystem == item.CurrencySystem.Code
              );
              if (total) {
                total.Amount += item.Total;
              } else {
                total = {
                  CurrencySystem: item.CurrencySystem.Code,
                  Amount: item.Total,
                };
                supplier.Totals.push(total);
              }
            }
          }
        }
      }
    });
  }

  handleDeleteSupplierItem(
    btn: MiezzButton,
    supplier: any,
    index: number,
    complete: () => void
  ): void {
    supplier.Items?.splice(index, 1);
    this.handleSupplierCalc();
    complete();
  }

  handleAddSupplierItem(
    btn: MiezzButton,
    supplier: any,
    complete: () => void
  ): void {
    const item = new DtoFormPriceQuotationSheet_PriceQuotationSheetItem();
    item.Cost = {};
    item.CurrencySystem = {};
    supplier.Items?.push(item);
    complete();
  }

  /**获取供应商 */
  getSuppliers(q: string, cb: any): void {
    if (q) {
      cb(this._suppliers.filter((it) => it.Name?.contains(q)));
    } else {
      cb(this._suppliers);
    }
  }

  supplierContacts: UiSelectOption<string>[] = [];
  /**供应商-供应商变更时 */
  handleSelectSupplier(item: DtoSelectOptionCompany): void {
    this.supplierContacts = [];
    this.modalDataSupplier.SupplierContacts = undefined;
    if (item && item.Id && item.Name == this.modalDataSupplier.SupplierName) {
      CompanyContactAppService.GetSelect({
        CompanyId: item.Id,
      }).then((r) => {
        this.supplierContacts = r.data.Data ?? [];
      });
    }
    (
      (this.$refs["ref-supplier-name"] as MiezzInput).$refs[
        "ref-miezz-input"
      ] as any
    ).blur();
  }

  /**供应商-获取联系人 */
  getSupplierCompanyContact(q: string, cb: any): void {
    cb(this.supplierContacts.filter((it) => it.Label?.contains(q)) ?? []);
  }

  /**按钮点击 */
  handleClick(btn: MiezzButton, complete: () => void): void {
    switch (btn.Code) {
      case "add-supplier-submit":
        (this.$refs["ruleFormSupplier"] as any).validate((v: boolean) => {
          if (!v) {
            setTimeout(() => {
              const error = document
                .getElementsByClassName("rule-form-supplier")[0]
                .getElementsByClassName("el-table__body")[0]
                .getElementsByClassName("is-error");
              error[0]?.querySelector("input")?.focus();
            }, 1);
            complete();
          } else {
            const scheme = this.form.Data.Schemes?.firstOrDefault(
              (it) => it.Name == this.schemeName
            );
            if (scheme) {
              const supplier = scheme.Suppliers?.firstOrDefault(
                (it) => it.SupplierName == scheme.SupplierName
              );
              if (supplier) {
                supplier.SupplierName = this.modalDataSupplier.SupplierName;
                supplier.SupplierContacts =
                  this.modalDataSupplier.SupplierContacts;
                scheme.SupplierName = supplier.SupplierName;
              } else {
                scheme.Suppliers?.push({
                  SupplierName: this.modalDataSupplier.SupplierName,
                  SupplierContacts: this.modalDataSupplier.SupplierContacts,
                  Items: [],
                  Totals: [],
                  Files: [],
                });
                scheme.SupplierName = this.modalDataSupplier.SupplierName;
              }
              this.modalSupplier.Show = false;
              complete();
            }
          }
        });
        complete();
        break;
      case "add-scheme-submit":
        (this.$refs["ruleFormScheme"] as any).validate((v: boolean) => {
          if (!v) {
            setTimeout(() => {
              const error = document
                .getElementsByClassName("rule-form-scheme")[0]
                .getElementsByClassName("el-table__body")[0]
                .getElementsByClassName("is-error");
              error[0]?.querySelector("input")?.focus();
            }, 1);
            complete();
          } else {
            const scheme = this.form.Data.Schemes?.firstOrDefault(
              (it) => it.Name == this.schemeName
            );
            if (scheme && !this.modalDataScheme.CopyName) {
              scheme.Name = this.modalDataScheme.Name;
              this.schemeName = scheme.Name;
            } else if (this.modalDataScheme.CopyName) {
              const copyScheme: DtoFormPriceQuotationSheet_Scheme = JSON.copy(
                this.form.Data.Schemes?.firstOrDefault(
                  (it) => it.Name == this.modalDataScheme.CopyName
                )
              );
              copyScheme.Name = this.modalDataScheme.Name;
              copyScheme.Id = undefined;
              for (const item of copyScheme.FieldValues ?? []) {
                item.Id = undefined;
              }
              for (const item of copyScheme.Items ?? []) {
                item.Id = undefined;
              }
              for (const supplier of copyScheme.Suppliers ?? []) {
                supplier.Id = undefined;
                for (const item of supplier.Files ?? []) {
                  item.Id = undefined;
                }
                for (const item of supplier.Items ?? []) {
                  item.Id = undefined;
                }
              }
              this.form.Data.Schemes?.push(copyScheme);
              this.schemeName = this.modalDataScheme.Name;
            } else {
              this.form.Data.Schemes?.push({
                Name: this.modalDataScheme.Name,
                FieldValues: [],
                Items: [],
                Totals: [],
                Suppliers: [],
              });
              this.schemeName = this.modalDataScheme.Name;
            }
            this.modalScheme.Show = false;
            complete();
          }
        });
        complete();
        break;
      case "add-field":
        this.modalFieldForm.Ids = [];
        this.handleFieldCheck();
        this.modalField.Show = true;
        complete();
        break;
      case "field-submit":
        (this.$refs["field-form"] as any).validate((v: boolean) => {
          if (v) {
            for (const id of this.modalFieldForm.Ids) {
              const field = this.fields.firstOrDefault((it) => it.Value == id);
              const item: any = {
                FieldId: id,
                Name: field?.Label,
              };
              if (field?.Data.Code == "SailingDate") {
                item.SailingTimeType = EnumSailingTimeType.Week;
                item.SailingWeeks = [];
                item.SailingWeekArray = [];
              } else if (field?.Data.Code == "Voyage") {
                item.VoyageUnit = EnumVoyageUnit.Day;
              }
              const scheme = this.form.Data.Schemes?.firstOrDefault(
                (it) => it.Name == this.schemeName
              );
              if (scheme && scheme.FieldValues) {
                scheme.FieldValues.push(item);
                console.log(scheme.FieldValues);
                this.buildFields();
              }
            }
            this.modalField.Show = false;
            complete();
          } else {
            complete();
          }
        });
        break;
      default:
        break;
    }
  }

  handleFieldRowButtonClick(
    btn: MiezzButton,
    index: number,
    complete: () => void
  ): void {
    switch (btn.Code) {
      case "delete-field":
        this.form.Data.Schemes?.firstOrDefault(
          (it) => it.Name == this.schemeName
        )?.FieldValues?.splice(index, 1);
        this.buildFields();
        complete();
        break;

      default:
        break;
    }
    complete();
  }

  handleFieldCheckAll(): void {
    this.modalFieldForm.Ids = this.modalFieldForm.CheckAll
      ? this.fields.map((it) => it.Value as string)
      : [];
    this.handleFieldCheck();
  }

  handleFieldCheck(): void {
    let total = this.fields.length;
    const len = this.modalFieldForm.Ids.length;
    this.modalFieldForm.CheckAll = len == total;
    this.modalFieldForm.CheckAllIndeterminate = len > 0 && len < total;
  }

  setOptions(i: number, options: UiSelectOption<string>[]): void {
    const fields = this.form.Data.Schemes?.firstOrDefault(
      (it) => it.Name == this.schemeName
    )?.FieldValues;
    if (fields) {
      fields[i].Options = options;
    }
  }

  @Watch("schemeName")
  onSchemeNameChanged(): void {
    this.buildFields();
  }

  buildFields(): void {
    const scheme = this.form.Data.Schemes?.firstOrDefault(
      (it) => it.Name == this.schemeName
    );
    if (scheme && scheme.FieldValues) {
      for (let i = 0; i < scheme.FieldValues.length; i++) {
        const item = scheme?.FieldValues[i];
        item.Code = this.fields.firstOrDefault(
          (it) => it.Value == item.FieldId
        )?.Data.Code;
        item.Options = item.Options ?? [];
        switch (item.Code) {
          case "CountryId":
            this.rules.CountryId = [
              {
                required: true,
                message: "信息不能为空",
                trigger: "change",
              },
            ];
            item.Query = (q: string) => {
              if (q) {
                ParamCountryAppService.GetSelect({ Keywords: q }).then((r) => {
                  this.setOptions(i, r.data.Data ?? []);
                });
              }
            };
            if (
              item &&
              item.CountryId &&
              item.Label &&
              item.Options.length == 0
            ) {
              item.Query(item.Label);
            }
            break;
          case "PortId":
            this.rules.PortId = [
              {
                required: true,
                message: "信息不能为空",
                trigger: "change",
              },
            ];
            item.Query = (q: string) => {
              if (q) {
                ParamPortAppService.GetSelect({ Keywords: q }).then((r) => {
                  this.setOptions(i, r.data.Data ?? []);
                });
              }
            };
            if (item && item.PortId && item.Label && item.Options.length == 0) {
              item.Query(item.Label);
            }
            break;
          case "AreaId":
            this.rules.AreaId = [
              {
                required: true,
                message: "信息不能为空",
                trigger: "change",
              },
            ];
            item.Query = (q: string) => {
              if (q) {
                ParamCountryAreaAppService.GetSelect({ Keywords: q }).then(
                  (r) => {
                    this.setOptions(i, r.data.Data ?? []);
                  }
                );
              }
            };
            if (item && item.AreaId && item.Label && item.Options.length == 0) {
              item.Query(item.Label);
            }
            break;
          case "CarrierId":
            this.rules.CarrierId = [
              {
                required: true,
                message: "信息不能为空",
                trigger: "change",
              },
            ];
            item.Query = (q: string) => {
              ParamCarrierAppService.GetSelect({ Keywords: q, Take: 10 }).then(
                (r) => {
                  this.setOptions(i, r.data.Data ?? []);
                }
              );
            };
            if (
              item &&
              item.CarrierId &&
              item.Label &&
              item.Options.length == 0
            ) {
              item.Query(item.Label);
            }
            break;
          case "ChannelId":
            this.rules.ChannelId = [
              {
                required: true,
                message: "信息不能为空",
                trigger: "change",
              },
            ];
            item.Query = (q: string) => {
              ParamTransportChannelAppService.GetSelect({
                Keywords: q,
                Take: 10,
              }).then((r) => {
                this.setOptions(i, r.data.Data ?? []);
              });
            };
            if (
              item &&
              item.ChannelId &&
              item.Label &&
              item.Options.length == 0
            ) {
              item.Query(item.Label);
            }
            break;
          case "RouteCodeId":
            this.rules.RouteCodeId = [
              {
                required: true,
                message: "信息不能为空",
                trigger: "change",
              },
            ];
            item.Query = (q: string) => {
              if (q) {
                ParamTransportRouteCodeAppService.GetSelect({
                  Keywords: q,
                }).then((r) => {
                  this.setOptions(i, r.data.Data ?? []);
                });
              }
            };
            if (
              item &&
              item.RouteCodeId &&
              item.Label &&
              item.Options.length == 0
            ) {
              item.Query(item.Label);
            }
            break;
          case "Voyage":
            item.Options = EnumVoyageUnitOption;
            this.rules.Voyage = [
              {
                required: true,
                message: "信息不能为空",
                trigger: "blur",
              },
            ];
            this.rules.VoyageUnit = [
              {
                required: true,
                message: "信息不能为空",
                trigger: "change",
              },
            ];
            break;
          case "SailingDate":
            item.Options = EnumSailingTimeTypeOption;
            if (item.SailingTimeType == EnumSailingTimeType.Week) {
              item.SailingWeekArray = item.SailingWeeks?.map(
                (it: any) => it.SailingWeek
              );
            }
            break;

          default:
            break;
        }
      }
    }
  }

  handleDeleteItem(
    btn: MiezzButton,
    scheme: any,
    index: number,
    complete: () => void
  ): void {
    scheme.Items?.splice(index, 1);
    this.handleCalc();
    complete();
  }

  handleAddItem(btn: MiezzButton, scheme: any, complete: () => void): void {
    const item = new DtoFormPriceQuotationSheet_PriceQuotationSheetItem();
    item.Cost = {};
    item.CurrencySystem = {};
    scheme.Items?.push(item);
    complete();
  }

  handleImport(items: DtoDetailPriceQuotationSheetSourceItem[]): void {
    for (const item of items) {
      this.form.Data.Schemes?.firstOrDefault(
        (it) => it.Name == this.schemeName
      )?.Items?.push(item);
    }
    this.handleCalc();
  }

  getServiceRemarks(q: string, cb: any): void {
    cb(
      this.serviceRemarks.filter((it) =>
        it.Label?.toUpperCase().contains(q.toUpperCase())
      )
    );
  }

  handleDeleteServiceRemark(
    select: UiSelectOption<string>,
    value: string
  ): void {
    var param = new DtoDeleteServiceRemark();
    param.Value = select.Value;
    OrderPoolAppService.DeleteServiceRemark(param).then(() => {
      const old = this.serviceRemarks.firstOrDefault((it) => it.Label == value);
      if (old?.Value == select.Value) {
        this.form.Data.ServiceRemark = undefined;
      } else {
        this.form.Data.ServiceRemark = old?.Label;
      }
      this.serviceRemarks = this.serviceRemarks.filter(
        (it) => it.Label != select.Label
      );
      ElMessage.success("历史记录已删除");
      return;
    });
  }

  /**获取客户企业 */
  getCosts(q: string, cb: any): void {
    this.filterCosts = JSON.copy(this.costs);
    if (q) {
      cb(this.filterCosts.filter((it) => it.Label?.contains(q)).slice(0, 10));
    } else {
      cb(this.filterCosts.slice(0, 10));
    }
  }

  handleSelectCost(
    row?: DtoFormPriceQuotationSheet_PriceQuotationSheetItem,
    item?: UiSelectOption<string>
  ): void {
    console.log(
      row && item && item.Value && item.Label == row.CostLabel && !item.Data
    );
    if (row) {
      if (item && item.Value && item.Label == row.CostLabel && !item.Data) {
        row.CostId = item.Value;
      } else {
        row.CostId = undefined;
      }
    }
    console.log(row, item);
  }

  handleDeleteCost(
    row: DtoFormPriceQuotationSheet_PriceQuotationSheetItem,
    select: UiSelectOption<string>,
    value: string
  ): void {
    console.log(row, select, value);
    PriceQuotationSheetAppService.DeleteCostOptionHistoryById(
      select.Value
    ).then(() => {
      const old = this.filterCosts.firstOrDefault((it) => it.Label == value);
      if (old?.Value == select.Value) {
        row.CostLabel = undefined;
      } else {
        row.CostLabel = old?.Label;
      }
      this.filterCosts = this.filterCosts.filter(
        (it) => it.Label != select.Label
      );
      ElMessage.success("历史记录已删除");
      return;
    });
  }
}
